import React, { useState, useRef, useEffect } from 'react';
import {cloneDeep} from "lodash";
import InvisiblePane from "../../Components/InvisiblePane";
import Text from "../../Components/Text";
import ProgressBar from "../../Components/ProgressBar";
import Pane from "../../Components/Pane";
import BackButton from "../../Components/BackButton";
import Button from "../../Components/Button";
import Details from "./Components/Details";
import PrimaryTitle from "../../Components/PrimaryTitle";
import {DEFAULT_ERROR_MESSAGE, SOURCE_OF_FUNDS_OPTIONS} from "../../constants";
import Error from "../../Components/Error";
import PageLoadingPanel from "../../Components/PageLoadingPanel";

const BankDetailsPage = (props) => {
    const {
        previousPage    = () => {},
        nextPage        = () => {}
    } = props;

    const PAGE_TITLE            = 'Bank Details';
    const CURRENT_STEP_NUMBER   = 5;
    const TOTAL_STEP_NUMBER     = 8;

    const [data, setData] = useState({
        'bank_name':             '',
        'account_holder_name':   '',
        'sort_code':             '',
        'account_number':        '',
        'source_of_funds_select':   '',
        'source_of_funds_other':    '',
        'source_of_funds':          '',
    });
    const [loaded, setLoaded]               = useState(false);
    const [errors, setErrors]               = useState(null);
    const [errorMessage, setErrorMessage]   = useState(null);
    const [submitting, setSubmitting]       = useState(false);

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        if (submitting) {
            submit();
        }
    }, [submitting]);

    const load = () => {
        axios.get(route('web-api.session.bank-details.get', {session: window.session}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    let data = response.data;

                    const matchingFund = SOURCE_OF_FUNDS_OPTIONS.find(
                        option => option.value === data.source_of_funds
                    );

                    if (matchingFund) {
                        data['source_of_funds_select'] = data.source_of_funds;
                    } else {
                        data['source_of_funds_select'] = 'Other';
                        data['source_of_funds_other'] = data.source_of_funds;
                    }

                    setData(data);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setLoaded(true);
            });
    }

    const submit = () => {
        setErrorMessage(null);

        axios.patch(route('web-api.session.bank-details.update', {session: window.session}).toString(), data)
            .then((response) => {
                setSubmitting(false);
                nextPage();
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        setErrorMessage(error.response.data.message);
                    }

                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    setSubmitting(false);
                } else {
                    console.log(error);
                    setErrorMessage(DEFAULT_ERROR_MESSAGE);
                }
            });
    }

    const updateField = (field, value) => {
        let clone = cloneDeep(data);

        switch (field) {
            default:
                clone[field] = value;
                break;
        }

        setData(clone);
    }

    const renderTopText = () => {
        return (
            <InvisiblePane style={{paddingTop: 0}}>
                <Text style={{marginBottom: '0', textAlign: 'center', fontWeight: 'bold'}}>Please check the business details - the better we understand your business, the easier it is for us to help you</Text>
            </InvisiblePane>
        );
    }

    if (!loaded) {
        return (
            <PageLoadingPanel
                pageTitle={PAGE_TITLE}
                currentStepNumber={CURRENT_STEP_NUMBER}
                totalStepNumber={TOTAL_STEP_NUMBER}
                upperTextComponent={renderTopText()}
            />
        )
    }

    return (
        <React.Fragment>
            {renderTopText()}
            {!!errorMessage && (
                <Error message={errorMessage} />
            )}
            <Pane>
                <ProgressBar
                    title={PAGE_TITLE}
                    currentStepNumber={CURRENT_STEP_NUMBER}
                    totalStepNumber={TOTAL_STEP_NUMBER}
                />
                <PrimaryTitle>{PAGE_TITLE}</PrimaryTitle>
                <Details
                    data={data}
                    onChange={(field, value) => updateField(field, value)}
                    disabled={submitting}
                    errors={errors}
                />
            </Pane>
            {!!errorMessage && (
                <Error message={errorMessage} />
            )}
            <InvisiblePane style={{paddingTop: '59px', paddingLeft: 0, paddingRight: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <BackButton
                    disabled={submitting}
                    onClick={() => previousPage()}
                />
                <Button
                    label={submitting ? 'Submitting...' : 'Next'}
                    disabled={submitting}
                    onClick={() => setSubmitting(true)}
                />
            </InvisiblePane>
        </React.Fragment>
    );
}

export default BankDetailsPage;
